import { Sort, SortBy } from '@uc/web/shared/feature/feature-filter';
import { EventsSearchPayload } from '../models/open-days.models';
import { ProductEnum } from '@uc/shared/data-models';

export const METADATA = {
	title: 'Book Your University Open Day | Uni Compare',
	description:
		'Book yourself onto a university open day! Browse from hundreds of undergraduate and postgraduate uni open days. Book now!',
};

export const HEADER_DATA_EVENT_SEARCH = {
	title: 'Search university events',
	description:
		'Get a feel for the campus, explore lecture halls and see the accommodation you’ll be staying in. Make sure the uni is the right fit for you with open days and campus tours.',
	backgroundStyle: 'bg-event-search',
};

export const SORT_OPTIONS: Sort[] = [
	{
		text: 'Earliest Date',
		sortBy: SortBy.Date,
		sortDir: 'ASC',
	},
	{
		text: 'Latest Date',
		sortBy: SortBy.Date,
		sortDir: 'DESC',
	},
];

export const FILTER_OPTIONS = {
	types: [
		{ id: 1, name: 'Open Day', url_name: 'open', checked: false },
		{ id: 2, name: 'Virtual Event', url_name: 'virtual', checked: false },
		{ id: 3, name: 'Campus Tour', url_name: 'campus', checked: false },
		{ id: 4, name: 'Webinar', url_name: 'webinar', checked: false },
		{ id: 5, name: 'Open Evening', url_name: 'evening', checked: false },
	],
};

export const INSERT_BY = {
	key: 'is_recommended',
	value: true,
} as const;

export const DEFAULT_EVENTS_SEARCH_PAYLOAD: EventsSearchPayload = {
	name: '',
	dateFrom: null,
	dateTo: null,
	typeIds: null,
	locationIds: null,
	product: ProductEnum.Undergraduate,
	sortBy: SortBy.Date,
	sortDirection: 'ASC',
	page: 1,
	limit: 20,
	offset: null,
};
